import { atom, useAtomValue, useSetAtom } from 'jotai';

/** 接待统计信息(顶部条初始化; 新会话时本地实时更新; 每隔5分钟获取服务端最新值) */
export const receptionBuyerState = atom<Conversation.ReceptionBuyerStat>({
  inReceptionCount: 0,
  waitAssignCount: 0,
  noOrderCount: 0,
  noPaymentCount: 0,
  paidCount: 0,
  receptionBuyerCount: 0,
  manualReceptionBuyerCount: 0,
  untreatedCount: 0,
  currentTimeMs: 0,
});

/** 获取`接待统计信息` */
export const useReceptionBuyer = () => {
  return useAtomValue(receptionBuyerState);
};

/** 设置`接待统计信息` */
export const useSetReceptionBuyer = () => {
  return useSetAtom(receptionBuyerState);
};
